var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('image-hotspots',{attrs:{"inspiration":this.inspiration,"initialImage":this.initialImage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }